"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "demoPageQuerySet", {
  enumerable: true,
  get: function () {
    return _demoPageQuerySet.demoPageQuerySet;
  }
});
var _demoPageQuerySet = require("./demoPageQuerySet");